import React, { useEffect, useRef, useState } from "react";


function Usaimport() {
  const [activeIndex, setActiveIndex] = useState(0);
  const sectionRefs = useRef([]);
  const contentRef = useRef(null);
  const titleRef = useRef(null);

  useEffect(() => {
    sectionRefs.current = sectionRefs.current.slice(0, 10);

    const observerOptions = {
      root: null,
      rootMargin: "0px",
      threshold: 0.1,
    };

    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          const index = sectionRefs.current.indexOf(entry.target);
          setActiveIndex(index);
        }
      });
    }, observerOptions);

    sectionRefs.current.forEach((section) => {
      observer.observe(section);
    });

    return () => {
      observer.disconnect();
    };
  }, []);

  const scrollToSection = (index) => {
    setActiveIndex(index);
    const section = sectionRefs.current[index];
    const contentElement = contentRef.current;

    const scrollPosition = section.offsetTop - contentElement.offsetTop;

    contentElement.scrollTo({
      top: scrollPosition,
      behavior: "smooth",
    });
  };

  return (
    <>
      <div className="flex flex-wrap">
        <div className=" flex flex-col items-center justify-center px-4 py-7 md:justify-between md:px-20 xl:flex-row"></div>

        <div className="mb-20 flex min-h-screen">
          <div
            ref={titleRef}
            className="sticky top-20 hidden h-screen w-1/4 overflow-y-auto bg-gray-100 p-4 md:block"
          >
            <ul className="space-y-2">
              <li
                onClick={() => scrollToSection(0)}
                className={`cursor-pointer p-12 ${
                  activeIndex === 0
                    ? "bg-blue-500 text-white"
                    : "bg-white text-[#2C3F69]"
                } shadow rounded-md`}
              >
                Family-Sponsored Visas
              </li>
              <li
                onClick={() => scrollToSection(1)}
                className={`cursor-pointer p-8 ${
                  activeIndex === 1
                    ? "bg-blue-500 text-white"
                    : "bg-white text-[#2C3F69]"
                } shadow rounded-md`}
              >
                Employment-Based Visas
              </li>
              <li
                onClick={() => scrollToSection(2)}
                className={`cursor-pointer p-12 ${
                  activeIndex === 2
                    ? "bg-blue-500 text-white"
                    : "bg-white text-[#2C3F69]"
                } shadow rounded-md`}
              >
                Non-Immigrant Visas
              </li>
              <li
                onClick={() => scrollToSection(3)}
                className={`cursor-pointer p-12 ${
                  activeIndex === 3
                    ? "bg-blue-500 text-white"
                    : "bg-white text-[#2C3F69]"
                } shadow rounded-md`}
              >
                Green Card
              </li>
              <li
                onClick={() => scrollToSection(4)}
                className={`cursor-pointer p-12 ${
                  activeIndex === 4
                    ? "bg-blue-500 text-white"
                    : "bg-white text-[#2C3F69]"
                } shadow rounded-md`}
              >
                Advantages of Relocating to the USA
              </li>
            </ul>
          </div>

          <div
            ref={contentRef}
            className="mb-10 h-screen overflow-y-auto p-4 md:w-3/4 lg:w-3/4 xl:w-3/4"
          >
            {/* Family-Sponsored Visas */}
            <div ref={(el) => (sectionRefs.current[0] = el)}>
              <p className="text-3xl font-bold text-[#011473]">
                Family-Sponsored Visas
              </p>
              <ul className="mt-4 list-disc pl-6 text-[#2C3F69]">
                <li>IR-1, CR-1: Spouse Visas for U.S. Citizens</li>
                <li>K-1: Fiancé Visas</li>
                <li>K-2: Children of K-1 Visa Holders</li>
                <li>K-3: Spouses of Green Card Holders</li>
                <li>K-4: Children of K-3 Visa Holders</li>
                <li>
                  IR-3, CR-2, IH-4: Visas for Adopted Orphans of U.S. Citizens
                </li>
                <li>F2A, F2B: Family Members of Lawful Permanent Residents</li>
              </ul>
            </div>

            {/* Employment-Based Visas */}
            <div ref={(el) => (sectionRefs.current[1] = el)} className="mt-10">
              <p className="text-3xl font-bold text-[#011473]">
                Employment-Based Visas
              </p>
              <ul className="mt-4 list-disc pl-6 text-[#2C3F69]">
                <li>EB-1: Priority Workers</li>
                <li>EB-2: Skilled Professionals</li>
                <li>EB-3: Other Workers</li>
                <li>EB-4: Certain Special Immigrants</li>
                <li>EB-5: Investor Visas</li>
              </ul>
            </div>

            {/* Non-Immigrant Visas */}
            <div ref={(el) => (sectionRefs.current[2] = el)} className="mt-10">
              <p className="text-3xl font-bold text-[#011473]">
                Non-Immigrant Visas
              </p>
              <ul className="mt-4 list-disc pl-6 text-[#2C3F69]">
                <li>A: Diplomatic and Foreign Government Officials</li>
                <li>B-1: Temporary Business Visitors</li>
                <li>B-2: U.S. Tourist Visa</li>
                <li>C: Transit Visas</li>
                <li>H1B: Highly Specialized Workers</li>
                <li>H2A: Agricultural Workers</li>
                <li>F and M: Student Visas</li>
                <li>J: Exchange Visitor Visas</li>
                <li>O: Individuals with Extraordinary Ability</li>
                <li>P: Artists, Athletes and Entertainers</li>
                <li>TN/TD: NAFTA Work Visas for Canadians and Mexicans</li>
              </ul>
            </div>

            {/* Green Card Section */}
            <div ref={(el) => (sectionRefs.current[3] = el)} className="mt-10">
              <p className="text-3xl font-bold text-[#011473]">Green Card</p>
              <ul className="mt-4 list-disc pl-6 text-[#2C3F69]">
                <li>
                  <strong>Family-Based Green Card:</strong> For individuals with
                  close family relationships with U.S. citizens, such as
                  spouses, children, parents, or siblings.
                </li>
                <li>
                  <strong>Employment-Based Green Card:</strong> For individuals
                  sponsored by their employers to work in the U.S.
                </li>
                <li>
                  <strong>Returning Resident Green Card:</strong> For those who
                  had a Green Card but were outside the U.S. for over a year due
                  to unavoidable circumstances.
                </li>
                <li>
                  <strong>Diversity Visa Green Card:</strong> Issued through the
                  U.S. visa lottery program for individuals from countries with
                  low immigration rates.
                </li>
              </ul>
            </div>

            {/* Benefits of Migrating to the USA */}
            <div ref={(el) => (sectionRefs.current[4] = el)} className="mt-10">
              <p className="text-3xl font-bold text-[#011473]">
                Advantages of Relocating to the USA
              </p>
              <ul className="mt-4 list-disc pl-6 text-[#2C3F69]">
                <li>Earn in U.S. dollars and benefit from worker’s rights</li>
                <li>Travel globally with a powerful U.S. passport</li>
                <li>Apply for family-based Green Cards</li>
                <li>Eligibility to vote in U.S. elections</li>
                <li>Visa options for spouses and fiancés</li>
                <li>Access U.S. citizenship and its privileges</li>
                <li>Participate in government-funded programs</li>
                <li>Explore opportunities for government employment</li>
                <li>Opportunities to serve in the U.S. Armed Forces</li>
                <li>Access to employment-sponsored visa programs</li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default Usaimport;
